import { themes, ThemeTypes } from '@polestar/component-warehouse-react/themes/Theme';
const Themes = Object.freeze({
    [ThemeTypes.light]: themes.light,
    [ThemeTypes.dark]: themes.dark,
});
export default Themes;
